import { Link } from "react-router-dom";

const NAV = [
  { label: "Publications", href: "https://theaie.net/publications" },
  { label: "Tools", href: "https://theaie.net/tools" },
  { label: "Events", href: "https://theaie.net/events" },
  { label: "Resources", href: "https://theaie.net/resources" },
  { label: "About", href: "https://theaie.net/about" },
];

const LOGO =
  "https://d2xsxph8kpxj0f.cloudfront.net/310419663031482000/MBYdsPaTEWW4CEpM7kCm6J/aie-logo-white_151f5987.png";

export default function Header() {
  return (
    <header className="sticky top-0 z-30 border-b border-white/10 backdrop-blur-md bg-ink/80">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between gap-6">
        <a
          href="https://theaie.net"
          className="flex items-center gap-3 flex-none"
          aria-label="The AIE Network — home"
        >
          <img
            src={LOGO}
            alt="The AIE Network"
            className="h-7 w-auto"
            loading="eager"
          />
          <span className="hidden sm:inline-block w-px h-5 bg-white/15" />
          <Link
            to="/"
            className="hidden sm:inline-block text-sm font-medium text-white/70 hover:text-flame transition"
          >
            Reviews
          </Link>
        </a>

        <nav className="hidden md:flex items-center gap-7 text-sm">
          {NAV.map((item) => (
            <a
              key={item.label}
              href={item.href}
              className="text-white/70 hover:text-white transition"
            >
              {item.label}
            </a>
          ))}
          <Link
            to="/submit"
            className="text-flame font-semibold hover:text-flame/80 transition"
          >
            Leave a review
          </Link>
          <a
            href="https://theaie.net/subscribe"
            className="px-4 py-2 rounded-lg bg-flame text-white font-semibold text-sm hover:brightness-110 transition"
          >
            Subscribe Free
          </a>
        </nav>

        {/* Compact mobile actions */}
        <div className="md:hidden flex items-center gap-3 text-sm">
          <Link to="/submit" className="text-flame font-semibold">
            Review
          </Link>
          <a
            href="https://theaie.net/subscribe"
            className="px-3 py-1.5 rounded-md bg-flame text-white font-semibold text-xs"
          >
            Subscribe
          </a>
        </div>
      </div>
    </header>
  );
}
